module.exports = __webpack_public_path__ + "static/media/automata-logo.89cbfb96.png";